import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.001 16C13.1055 16 14.001 15.1046 14.001 14C14.001 12.8954 13.1055 12 12.001 12C10.8964 12 10.001 12.8954 10.001 14C10.001 15.1046 10.8964 16 12.001 16Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2001 14.4L5.6001 14.4C4.49553 14.4 3.6001 13.5046 3.6001 12.4L3.6001 4.80005"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8003 14.4001L20.4003 14.4001"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
